import { render } from "./PagerRequestTypeTable.vue?vue&type=template&id=395f7c92"
import script from "./PagerRequestTypeTable.vue?vue&type=script&lang=js"
export * from "./PagerRequestTypeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__